export const getInitials = (name = "") => {
  const p = name.trim().split(" ");
  return p.length === 1
    ? p[0].slice(0, 2).toUpperCase()
    : (p[0][0] + p[p.length - 1][0]).toUpperCase();
};

const AVATAR_COLORS = ["#28B3B4", "#D6DF27", "#4a9960", "#7a5abd", "#c88a3a"];
export const avatarColor = (name = "") =>
  AVATAR_COLORS[((name.charCodeAt(0) || 0) + (name.charCodeAt(1) || 0)) % AVATAR_COLORS.length];

export const timeAgo = (iso) => {
  if (!iso) return "";
  const diff  = Date.now() - new Date(iso).getTime();
  const mins  = Math.floor(diff / 60000);
  const hours = Math.floor(mins / 60);
  const days  = Math.floor(hours / 24);
  if (days > 0)  return `${days}d ago`;
  if (hours > 0) return `${hours}h ago`;
  return `${mins}m ago`;
};

export const fmt = (iso) =>
  iso
    ? new Date(iso).toLocaleDateString("en-GB", {
        day: "2-digit", month: "short", year: "numeric",
      })
    : "—";

export const statusLabel = (status) => ({
  SUBMITTED:    "Pending PMO Review",
  MOVE_PENDING: "Move Pending",
  PMO_APPROVED: "At SCG Gate",
  ACTIVE:       "Active",
  ENDED:        "Ended",
  REJECTED:     "Rejected",
}[status] || status);